export default __webpack_public_path__ + "static/media/no-message.7e16bc8d.svg";